import StageBadge from './ui/StageBadge';
import { formatDateTime } from '../utils/formatters';

export default function StageTimeline({ history = [] }) {
  if (history.length === 0) {
    return <p className="text-sm text-gray-400">No stage history yet.</p>;
  }

  return (
    <div className="relative">
      <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-gray-200" aria-hidden="true" />
      <div className="space-y-4">
        {history.map((entry, i) => (
          <div key={entry.id || i} className="relative flex items-start gap-4 pl-10">
            <div className="absolute left-2.5 top-1.5 h-3 w-3 rounded-full bg-brand-600 border-2 border-white ring-2 ring-brand-200" aria-hidden="true" />
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                {entry.from_stage && (
                  <>
                    <StageBadge stage={entry.from_stage} />
                    <span className="text-gray-400 text-xs">&rarr;</span>
                  </>
                )}
                <StageBadge stage={entry.to_stage} />
              </div>
              {entry.note && <p className="text-sm text-gray-600 mt-1">{entry.note}</p>}
              <p className="text-xs text-gray-400 mt-1">
                {entry.changed_by_name && <span>{entry.changed_by_name} &middot; </span>}
                {formatDateTime(entry.created_at)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
